export function parseBoolean(value: unknown): boolean {
  return typeof value === 'string' && value.toLocaleLowerCase() === 'true'
}
